import router from "./index";
import store from '../store'

// 白名单 
const whiteList = ['/xyd/welcome', '/xyd/login', '/xyd/index', '/xyd/system_introduced', '/xyd/policy_guidelines', '/xyd/guide_detail', "/xyd/brand_xy", "/xyd/brand_zx", "/xyd/brand_xb", "/xyd/brand_v", '/xyd/contact', "/xyd/credit_share", "/xyd/brand_zc", "/xyd/brand_gz", '/xyd/4-1"', '/xyd/4-2', '/xyd/4-1', '/xyd/publicCredit', "/xyd/creditDetails", "/xyd/Supermarket", "/xyd/product_details", "/xyd/h5/productDetails", "/xyd/h5/productList", "/xyd/product_list_details", "/xyd/fangyihome", "/xyd/newyearbiggift", "/xyd/numberyuan", "/xyd/moreShow", "/xyd/onlineAuth", "/xyd/summList"];
// 路由拦截
router.beforeEach((to, from, next) => {
    var that = this;
    const token = sessionStorage.getItem("token");
    if (token) {
        if (store.getters.sourceType || sessionStorage.getItem("sourceType")) {
            if (to.path == "/xyd/apply_loan" && store.getters.sourceType !== '1') {
                that.$message.success('本账号暂无权限')
                // next(false)
            } else {
                next();
            }
        } else {
            // 获取登录人信息的接口
            next()
        }
    } else {
        // debugger
        if (whiteList.indexOf(to.path) !== -1) {
            next();
        } else {
            next(`/xyd/login`);
            // next(`/xyd/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
        }
    }
});

